import React from "react";
import { Check } from "lucide-react";

import styles from "./PaymentOptionCard.module.scss";
import classNames from "classnames";

interface PaymentOptionCardProps {
  logo: React.ReactNode;
  label: string;
  isConnected: boolean;
  selected: boolean;
  onClick: () => void;
}

const PaymentOptionCard: React.FC<PaymentOptionCardProps> = ({
  logo,
  label,
  isConnected,
  selected,
  onClick,
}) => {
  return (
    <div
      className={classNames(
        styles.optionCard,
        isConnected && styles.active,
        selected && styles.selected,
      )}
      onClick={onClick}
    >
      <div className={styles.content}>
        <div className={styles.iconWrapper}>{logo}</div>
        <span className={styles.text}>{label}</span>
      </div>
      <Check
        className={classNames(styles.checkIcon, !isConnected && styles.hidden)}
      />
    </div>
  );
};

export default PaymentOptionCard;
